import React, { useState } from "react";
import { Callout, DirectionalHint, TooltipHost } from "@fluentui/react";

import { gfile } from "../../interfaces";

import styles from "./FileDropdown.module.css";

import { MdOutlineKeyboardArrowDown } from "react-icons/md";
import { SiInstructure } from "react-icons/si";
import { TbListSearch } from "react-icons/tb";
import { FiYoutube } from "react-icons/fi";
import { CgWebsite } from "react-icons/cg";





interface FileDropdownProps {
    file?: gfile;
    fileListStateVar: gfile[];
    handleFileClick: (target: EventTarget, fl: gfile, flIndex: number) => void;
    onContentShow?: (fl: gfile | undefined, flIndex: number | undefined) => void;
    activeFileId?: string;
    isStructureSideBarOpen?: boolean;
    setStructureSideBar: (isOpen: boolean) => void;
    hasExtraData: boolean;
    groupType: string;
}
import { pdfI } from "./../detailedList/detailedMdls";
const FileDropdown: React.FC<FileDropdownProps> = ({
    file,
    fileListStateVar,
    handleFileClick,
    onContentShow,
    activeFileId,
    isStructureSideBarOpen,
    setStructureSideBar,
    hasExtraData,
    groupType
}) => {
    const [menuVisible, setMenuVisible] = useState<boolean>(false);
    const [targetElement, setTargetElement] = useState<HTMLElement | null>(null);
    const [isHoveringMenu, setIsHoveringMenu] = useState<boolean>(false);

    const onSpaceFileListMouseClick = (event: React.MouseEvent<HTMLDivElement>) => {
        setTargetElement(event.currentTarget);
        setMenuVisible(true);
    };
    const onItemClick = (event: React.MouseEvent<HTMLDivElement>, fl: gfile, flIndex: number) => {
        handleFileClick(event.target, fl, flIndex);
        setMenuVisible(false);
    };

    return (
        <div className={styles.pdfMoHeadText}>

                <div className={`${(file?.contentlist?.length ?? 0) < 1 ? groupType == 'dpa' ? styles.fileTitleAndIconContainerUCH : styles.fileTitleAndIconContainerNoContent : groupType == 'dpa' ? styles.fileTitleAndIconContainerUCH : styles.fileTitleAndIconContainer}`}>
                    <div
                        className={`${(file?.contentlist?.length ?? 0) < 1 ? styles.fileListIconNoFileContent : styles.fileListIcon}`}
                        onClick={() => {onContentShow && onContentShow(file, parseInt(activeFileId || "0"))}}
                    >
                        <div className={`${(file?.contentlist?.length ?? 0) < 1 ? styles.fileListOnlyIconNoContent : styles.fileListOnlyIcon}`}>
                            <TbListSearch size={28} />
                        </div>
                    </div>
                    {/* file name */}

                    <TooltipHost content={file?.name ? `${file.name} - click to copy filename` : ""} directionalHint={DirectionalHint.bottomCenter} hostClassName={styles.fileTitleText}>
                        <div
                            className={styles.fileTitleText}
                            style={{ cursor: "pointer" }}
                            onClick={() => {
                                if (file?.name) navigator.clipboard.writeText(file.name).catch(() => {});
                            }}
                        >
                            {file?.name}
                        </div>
                    </TooltipHost>

                    {/* button to show document list */}
                    <div className={`${fileListStateVar.length < 1 ? styles.fileListDownIconLessThenTwoDocs : styles.fileListDownIcon}`} onClick={onSpaceFileListMouseClick}>
                        <MdOutlineKeyboardArrowDown size={28} />
                    </div>
                    {hasExtraData && (
                        <div className={styles.structureSideOpenButton} onClick={() => {setStructureSideBar(!isStructureSideBarOpen)}}>
                            <TooltipHost content={isStructureSideBarOpen ? "Close Structured Data Sidebar" : "Open Structured Data Sidebar"} directionalHint={DirectionalHint.bottomCenter}>
                                <SiInstructure size={17} />
                            </TooltipHost>
                        </div>
                    )}
                </div>


            <div id="pdfTtldrpTrg" className={styles.targetEl}></div>
            {menuVisible == true && (
                <Callout
                    className={styles.fileListCallout}
                    onDismiss={() => setMenuVisible(false)}
                    directionalHint={DirectionalHint.bottomLeftEdge}
                    isBeakVisible={false}
                >
                    <div className={styles.fileListHeader}>Assistant Content</div>
                    <div className={styles.fileListHeaderSub}></div>
                    <div className={styles.scrollableDocList} style={{ margin: 0, padding: 0, listStyle: "none" }}>
                        {fileListStateVar.map((fl: gfile, flIndex: number) => (
                            <div
                                key={`FL_${flIndex}`}
                                onClick={event => onItemClick(event, fl, flIndex)}
                                className={`${styles.contentFile} ${fl.fileid === activeFileId ? styles.pdfContFileSelected : ""}`}
                                style={{
                                    padding: "8px",
                                    cursor: "pointer",
                                    verticalAlign: "middle",
                                    textAlign: "left",
                                    display: "flex",
                                    alignItems: "center",
                                    zIndex: 99999999
                                }}
                            >
                                {fl.sourcetype == "youtube" ? <FiYoutube /> : fl.sourcetype == "web" ? <CgWebsite /> : pdfI}
                                <div style={{ width: "3px" }}></div>
                                {fl.name.split(".").slice(0, -1).join(".")}
                            </div>
                        ))}
                    </div>
                </Callout>
            )}
        </div>
    );
};

export default FileDropdown;
